/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_View_MapInputs */

const en_colleague_view_map = /** @type {(inputs: Colleague_View_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map`)
};

const ja_colleague_view_map = /** @type {(inputs: Colleague_View_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地図`)
};

const fr_colleague_view_map = /** @type {(inputs: Colleague_View_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte`)
};

const de_colleague_view_map = /** @type {(inputs: Colleague_View_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karte`)
};

/**
* | output |
* | --- |
* | "Map" |
*
* @param {Colleague_View_MapInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_view_map = /** @type {((inputs?: Colleague_View_MapInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_View_MapInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_view_map(inputs)
	if (locale === "ja") return ja_colleague_view_map(inputs)
	if (locale === "fr") return fr_colleague_view_map(inputs)
	return de_colleague_view_map(inputs)
});